import withLoader from "../../../components/layouts/WithLoader";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { Alert } from "@material-ui/lab";
import { Snackbar } from "@material-ui/core";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ChargeService from "../../../services/ChargesPayement/ChargeService";
import SocieteService from "../../../services/Societe";
import DataChargeList from "./DataChargeList";
import CashRegisterService from "../../../services/ProductSellBToC/CashRegisterService";
import ShopService from "../../../services/PosService/ShopService";

const PayementCharges = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const [yearSelected, setYearSelected] = useState(null);
  const [yearSelectedOption, setYearSelectedOption] = useState(null);
  const [allYears, setAllYears] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [monthPlaceholder, setMonthPlaceholder] = useState("Choisir...");
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [finalMonth, setFinalMonth] = useState("");
  const [finalYear, setFinalYear] = useState("");

  const [yearSelectPlaceHolder, setYearSelectPlaceHolder] =
    useState("Choisir...");

  const [listTransactions, setListTransactions] = useState([]);
  const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [allMagasin, setAllMagasin] = useState([{ value: 0, label: "aucun" }]);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("aucun");
  const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption("");
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label);
  };
  const onAddAvanceHandler = () => {
    navigate(`/ajouterCharge`);
  };
  useEffect(() => {
    if (localStorage.getItem("status") == null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
  }, []);

  useEffect(() => {
    setAllYears([]);
    setMonthsOptions([]);
    if (localStorage.getItem("status").includes("ADMIN")) {
      CashRegisterService.getAllShop(getCurrentUserId())
        .then((response) => {
          if (response.data.success) {
            response.data.success.map((element) => {
              setAllMagasin((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.name },
              ]);
            });
            // setAvailableShop(response.data.success);
          } else {
            console.log("error in getAllShop", response.data.success);
          }
        })
        .catch((e) => {
          console.log("error in getAllShop", e);
        });
    } else if (localStorage.getItem("status").includes("DIRECTEUR_MAGASIN")) {
      ShopService.getAllShopByManager(getCurrentUserId())
        .then((response) => {
          if (response.data.success) {
            response.data.success.map((element) => {
              setAllMagasin((oldArray) => [
                ...oldArray,
                { value: element.id, label: element.name },
              ]);
            });
          } else if (response.data.error) {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : " + response.data.error);
          }
        })
        .catch((e) => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : " + e);
          console.log("error in getAllShop", e);
        })
        .finally(() => {
          stopLoading();
        });
    }

    SocieteService.getFinacialYearsAndMonthsFromSocieteCreationDate()
      .then((response) => {
        if (response.data["success"] !== undefined) {
          const today = new Date();
          const mm = String(today.getMonth() + 1).padStart(2, "0");
          const yyyy = today.getFullYear();
          setYearSelected(yyyy);
          setYearSelectPlaceHolder(yyyy);
          if (mm === "01") {
            setFinalMonth("01");
            setMonthPlaceholder("Janvier");
          } else if (mm === "02") {
            setFinalMonth("02");
            setMonthPlaceholder("Février");
          } else if (mm === "03") {
            setFinalMonth("03");
            setMonthPlaceholder("Mars");
          } else if (mm === "04") {
            setFinalMonth("04");
            setMonthPlaceholder("Avril");
          } else if (mm === "05") {
            setFinalMonth("05");
            setMonthPlaceholder("Mai");
          } else if (mm === "06") {
            setFinalMonth("06");
            setMonthPlaceholder("Juin");
          } else if (mm === "07") {
            setFinalMonth("07");
            setMonthPlaceholder("Juiliet");
          } else if (mm === "08") {
            setFinalMonth("08");
            setMonthPlaceholder("Aout");
          } else if (mm === "09") {
            setFinalMonth("09");
            setMonthPlaceholder("Septembre");
          } else if (mm === "10") {
            setFinalMonth("10");
            setMonthPlaceholder("Octobre");
          } else if (mm === "11") {
            setFinalMonth("11");
            setMonthPlaceholder("Novembre");
          } else if (mm === "12") {
            setFinalMonth("12");
            setMonthPlaceholder("Decemebre");
          }
          const yearsOptions = response.data["success"].years.map(
            (year, index) => ({
              value: year,
              label: year,
            })
          );
          setAllYears([...yearsOptions]);
          const orderedMonth = response.data["success"].months.map((month) =>
            parseInt(month)
          );
          orderedMonth.sort((a, b) => a - b);
          setMonthsOptions([
            { value: "any", label: "tous" },
            { value: "01", label: "Janvier" },
            { value: "02", label: "Février" },
            { value: "03", label: "Mars" },
            { value: "04", label: "Avril" },
            { value: "05", label: "Mai" },
            { value: "06", label: "Juin" },
            { value: "07", label: "Juillet" },
            { value: "08", label: "Aout" },
            { value: "09", label: "Septembre" },
            { value: "10", label: "Octobre" },
            { value: "11", label: "Novembre" },
            { value: "12", label: "Decembre" },
          ]);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      });
  }, []);
  const onChangeSelectedYear = (selectedOptionn) => {
    setSelectedOption();
    setYearSelected(selectedOptionn.value);
    setFinalYear(selectedOptionn.value);
    setYearSelectPlaceHolder(selectedOptionn.label);
  };
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
    setFinalMonth(selectedOption.value);
    setMonthPlaceholder(selectedOption.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const listeChargeEtat = (e) => {
    startLoading();
    ChargeService.getChargeEtat(
      getCurrentUserId(),
      finalMonth,
      finalYear,
      magasinId
    )
      .then((response) => {
        console.log(response);
        if (response.data["error"]) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur :  " + response.data["error"]);
        } else {
          setListTransactions(response?.data?.success);
          setTotalCount(response?.data?.sum[0]?.count);
          setTotalAmount(response?.data?.sum[0]?.totalPrice);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :  " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              Charges de l'état
              <div className="row">
                <div class="col-md-10"></div>
                <div class="col-md-2">
                  {(userRole.includes("ADMIN") ||
                    userRole.includes("DIRECTEUR_MAGASIN")) && (
                    <button
                      class="btn btn-dark  float-right"
                      onClick={onAddAvanceHandler}
                    >
                      {" "}
                      Ajouter Charge
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <label htmlFor="inputClientCompany">
                      Choisir le magasin
                    </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={magasinSelectedOption}
                      onChange={onChangeSelectedMagasin}
                      options={allMagasin}
                      placeholder={magasinSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div class="form-group col-sm-4">
                  <div>
                    <label>Choisir l'année </label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={yearSelectedOption}
                      onChange={onChangeSelectedYear}
                      options={allYears}
                      placeholder={yearSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="form-group col-sm-4">
                  <div>
                    <label>Choisir le mois</label>
                    <Select
                      value={selectedMonth}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      options={monthsOptions}
                      onChange={handleMonthChange}
                      defaultValue={selectedMonth}
                      placeholder={monthPlaceholder}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="col-12">
                <button
                  type="submit"
                  onClick={listeChargeEtat}
                  className="btn btn-dark float-right"
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {listTransactions && listTransactions.length !== 0 && (
        <section className="content-header">
          <div className="row">
            {totalAmount !== null && (
              <div className="col-sm-6 col-12">
                <div className="info-box bg-gray-dark">
                  <span className="info-box-icon">
                    <i class="fas fa-sack-dollar"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Montant Total</span>
                    <span className="info-box-number">{totalAmount}</span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                    <span className="progress-description"></span>
                  </div>
                </div>
              </div>
            )}
            {totalCount !== null && (
              <div className="col-sm-6 col-12">
                <div className="info-box bg-gray-dark">
                  <span className="info-box-icon">
                    <i class="fas fa-hand-holding-dollar"></i>{" "}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Nombre </span>{" "}
                    <span className="info-box-number">{totalCount}</span>
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                    <span className="progress-description">
                      {/* 70% Increase in 30 Days */}
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="container-fluid">
            <DataChargeList
              listTransaction={listTransactions}
              allMagasin={allMagasin}
            />
          </div>
        </section>
      )}

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(PayementCharges);
